import React from "react";

export default function Header(){
  return (
    <header className="header">
      <div className="container header-inner">
        <div className="brand">
          <span className="gradient">RollUpAndDown </span>
          <span className="brand-underline" />
        </div>

      </div>
    </header>
  );
}

